module.exports = __webpack_public_path__ + "img/icon-93.af1950e1.png";